import React from "react";

export default function Footer() {
  return (
    <footer>
      <p>
        Designed and Developed by{" "}
        <a
          href='https://github.com/mattbowen03'
          target='_blank'
          rel='noreferrer'>
          mattbowen03
        </a>
        <br />
        Copyright 2022
      </p>
    </footer>
  );
}
